module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/xpelv6-f4046970dd517c2d8a8c91ab37fc629e.jpg";